// Copyright (c) 2025 Signal from Noise, Inc. All rights reserved.
//
// This software is the confidential and proprietary information of
// Signal from Noise, Inc. You shall not disclose such Confidential Information
// and shall use it only in accordance with the terms of a separate license
// agreement entered into with Signal from Noise, Inc.
//
// Authors: /AUTHORS

// DO NOT EDIT.
// Code generated in 2025 by '/services/controlplane/generate/websocket_client/websocket_client.go'
// This file is intended for version control.

import type { assets } from "./encore.gen";
import type { curator } from "./encore.gen";
import type { stid } from "./encore.gen";
import type { users } from "./encore.gen";

export const Commands = {
  UsersMergeCmdKeyV1: "users.merge:v1",
  AssetCreateCmdKeyV1: "assets.asset.create:v1",
  AssetGetByIDCmdKeyV1: "curator.assets.get_by_id:v1",
  AssetUpdateAssetStatusCmdKeyV1: "assets.asset.update_status:v1",
  UserAuthSyncCmdKeyV1: "users.authSync:v1",
  AssetRenameCmdKeyV1: "curator.assets.rename:v1",
  CollectionChangeAttrCmdKeyV1: "curator.collection.change_attributes:v1",
  ThreadRenameCmdKeyV1: "curator.threads.rename:v1",
  CollectionClaimTokenCmdKeyV1: "collections.claimToken:v1",
  CollectionAssociateAssetsCmdKeyV1: "collections.assocAssets:v1",
  CollectionCollectionAssociateThreadsCmdKeyV1: "collections.assocThreads:v1",
  CollectionCreateCmdKeyV1: "collections.create:v1",
  CollectionDeleteOpenDomainInviteCmdKeyV1: "collections.share:v1",
  CollectionGetAssetsByCollectionIDCmdKeyV1: "collections.getAssetsByCollectionID:v1",
  CollectionGetCountAssetsByCollectionIDCmdKeyV1: "collections.getCountAssetsByCollectionID:v1",
  CollectionGetIDCmdKeyV1: "collections.getID:v1",
  CollectionGetThreadsByCollectionIDCmdKeyV1: "collections.getThreadsByCollectionID:v1",
  CollectionGetTreeCmdKeyV1: "collections.getTree:v1",
  CollectionModifyPermissionsCmdKeyV1: "collections.modify_permissions:v1",
  CollectionAcceptSecretLinkCmdKeyV1: "collections.acceptSecretLink:v1",
  CollectionDeleteSecretLinkCmdKeyV1: "collections.deleteSecretLink:v1",
  CollectionShareCmdKeyV1: "collections.share:v1",
  AssetTombstoneCmdKeyV1: "curator.assets.tombstone:v1",
  CollectionDeleteCmdKeyV1: "curator.collection.delete:v1",
  CollectionDeleteTokenCmdKeyV1: "collections.deleteToken:v1",
  ThreadTombstoneCmdKeyV1: "curator.threads.tombstone:v1",
  CollectionAccessListCmdKeyV1: "collections.accessList:v1",
  CollectionMoveCmdKeyV1: "curator.collection.move:v1",
  AssetNotifyUploadCmdKeyV1: "assets.asset.notifyUpload:v1",
  ListForAssetsIDCmdKeyV1: "assets.list_recent:v1",
  SearchForAssetsIDCmdKeyV1: "assets.search_for:v1",
  StoredPromptCreateCmdKeyV1: "stored_prompts.create:v1",
  StoredPromptDeleteCmdKeyV1: "curator.stored_prompt.delete:v1",
  StoredPromptUpdateCmdKeyV1: "curator.stored_prompt.update:v1",
  ThreadRemoveAttachmentCmdKeyV1: "curator.remove_thread_attachment:v1",
  ThreadUpdateAttachmentCmdKeyV1: "curator.update_thread_attachment:v1",
  ThreadAddAttachmentsCmdKeyV1: "curator.add_thread_attachments:v1",
  ThreadCreateCmdKeyV1: "curator.create:v1",
  ThreadGetIDCmdKeyV1: "curator.getID:v1",
  ThreadMessageCmdKeyV1: "curator.message:v1",
  ShareThreadCmdKeyV1: "curator.share:v1",
  PingCmdKeyV1: "ws.ping:v1",
};

// CommandKey provides controlled references to CommandKey values.
export type CommandKey = typeof Commands[keyof typeof Commands];
export const encodeUserAuthSyncCmdParams = (v: users.UserAuthSyncCmdParams): string =>  {
  return btoa(JSON.stringify(v));
}
export const decodeAuthSyncResult = (v: string): users.AuthSyncResult => {
  return JSON.parse(atob(v));
}
export const encodeCollectionStringID = (v: stid.CollectionStringID): string =>  {
  return btoa(JSON.stringify(v));
}
export const decodeCollectionState = (v: string): curator.CollectionState => {
  return JSON.parse(atob(v));
}
export const encodeAssetNotificationPayload = (v: assets.OnUploadAssetCmdParams): string =>  {
  return btoa(JSON.stringify(v));
}
export const decodeAssetState = (v: string): assets.AssetState => {
  return JSON.parse(atob(v));
}
export const encodeStoredPromptStringID = (v: stid.StoredPromptStringID): string =>  {
  return btoa(JSON.stringify(v));
}
export const decodeStoredPromptState = (v: string): curator.StoredPromptState => {
  return JSON.parse(atob(v));
}
export const encodeCreateThreadCmdParams = (v: curator.CreateThreadCmdParams): string =>  {
  return btoa(JSON.stringify(v));
}
export const decodeThreadState = (v: string): curator.ThreadState => {
  return JSON.parse(atob(v));
}
export const encodeThreadStringID = (v: stid.ThreadStringID): string =>  {
  return btoa(JSON.stringify(v));
}
export const encodeMessageCmdParams = (v: curator.MessageCmdParams): string =>  {
  return btoa(JSON.stringify(v));
}
export const encodeShareThreadCmdParams = (v: curator.ShareThreadCmdParams): string =>  {
  return btoa(JSON.stringify(v));
}
